<template>
  <a class="generic-button" @click="$emit('clicked')">
    <i :class="iconClass"></i>
  </a>
</template>

<script>

export default {
  name: 'GenericButton',
   components: {
       
    },
    props: {
       iconClass: {
         type: String,
         required: true
       }
    },
	data(){
		return {
           
		}
	},
	methods: {

	}
};
</script>

<style lang="scss">
.generic-button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/buttons/GenericButton.vue